import { Component, HostListener } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { GtmService } from "src/app/shared/services/gtm-service/gtm.service";
import { StoreService } from "src/app/shared/services/store.service";
import { environment } from "src/environments/environment";
import { LoanDashboardService } from "../../../../loan-dashboard.service";

@Component({
    selector: "web-kyc-needed",
    templateUrl: "./kyc-needed.component.html",
    styleUrls: ["./kyc-needed.component.scss"],
})
export class KycNeededComponent {
    dgLockerConsentForm!: FormGroup;
    private readonly kycUrl = `${environment.baseUrl}/customer/digi/locker/step`;
    private popupRef: Window | null = null;

    constructor(
        private dialog: MatDialog,
        private fb: FormBuilder,
        private storeService: StoreService,
        private router: Router,
        private gtmService: GtmService,
        private loanDashboardService: LoanDashboardService
    ) {}

    ngOnInit() {
        this.dgLockerConsentForm = this.fb.group({
            isAgreed: [false, Validators.requiredTrue],
        });
    }

    startKyc(): void {
        const token = this.storeService.get("token");
        if (!token) {
            console.warn("Token not found.");
            return;
        }

        const popupUrl = `${this.kycUrl}?token=${token}`;
        const width = 800;
        const height = 600;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;

        const popupFeatures = `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`;

        if (!this.popupRef || this.popupRef.closed) {
            this.popupRef = window.open(popupUrl, "_blank", popupFeatures);

            // Track external popup opened for DigiLocker re-KYC
            this.gtmService.trackPopupOpened("digilocker_rekyc_popup", {
                popup_type: "external_window",
                popup_url: popupUrl,
                popup_size: `${width}x${height}`,
                popup_trigger: "re_kyc_process",
            });
        }
    }

    @HostListener("window:message", ["$event"])
    handlePopupEvents(event: MessageEvent): void {
        const eventType = event?.data?.event;
        const eventMessage = event?.data?.data?.message || "Verification failed. Please try again.";

        if (eventType === "master-digiLocker-success") {
            // Track popup closed with success
            this.gtmService.trackPopupClosed("digilocker_rekyc_popup", {
                close_reason: "success",
                interaction_type: "digilocker_success",
            });

            // GTM: aadhar_verified_success (from Events.xlsx)
            this.gtmService.trackConfigEvent("AADHAR_VERIFIED_SUCCESS", {
                verification_time: new Date().toISOString(),
            });

            this.loanDashboardService.getDashboardDetails(true);
        } else if (eventType === "master-digiLocker-error") {
            // Track popup closed with error or cancellation

            // GTM: aadhar_verified_success (from Events.xlsx)
            this.gtmService.trackConfigEvent("AADHAR_VERIFIED_FAIL", {
                verification_time: new Date().toISOString(),
                reason: eventType.includes("error") ? "error" : "user_cancelled",
            });

            this.gtmService.trackPopupClosed("digilocker_rekyc_popup", {
                close_reason: eventType.includes("error") ? "error" : "user_cancelled",
                interaction_type: eventType.replace("digiLocker-", ""),
            });
            this.closePopupAndRedirect(eventMessage);
        }
    }

    private closePopupAndRedirect(message: string): void {
        if (this.popupRef && !this.popupRef.closed) {
            this.popupRef.close();
            this.popupRef = null;
        }
        this.router.navigate(["/loan/info"], {
            state: {
                isInnerHtml: true,
                icon: "assets/svg/icons/cross-circle-gbs.svg",
                title: "Verification Failed",
                description: ` <h3 class="bottom-assisttext-60 text-center">
                  ${message}
                </h3>`,
                rightButtonName: "Try again",
                rightButtonRoute: "/loan/kyc-needed",
                navEntries: false,
            },
        });
    }
}
